export default "/images/5cf0adb99c59bfe00dae975c81eec72d.avif";